import Vue from "vue"
import BreakpointsPlugin from "@soenergy/frontend-library/src/plugins/breakpoints"

Vue.use(BreakpointsPlugin)
